/// <reference lib="dom"/>
export const MicConstraints: MediaTrackConstraints = {
  echoCancellation: false,
  noiseSuppression: false,
  autoGainControl: false,
};

export function WbaNodeId(id: string): string {
  const parts = id.split(/[./]/).filter(Boolean);
  return `/${parts.join("/")}`;
}

export function MicErrorMessage(e: unknown): string {
  if (e instanceof DOMException) {
    switch (e.name) {
      case "NotFoundError":
        return "no microphone found - check an input device is connected";
      case "NotAllowedError":
        return "microphone access was denied - check the browser/site permission";
      case "NotReadableError":
        return "microphone is already in use by another application";
      case "OverconstrainedError":
        return "no microphone matches the requested audio settings";
      case "SecurityError":
        return "microphone access is blocked in this context (needs https or localhost)";
      default:
        return `microphone error: ${e.name}`;
    }
  }
  return e instanceof Error ? e.message : String(e);
}
